<template>
  <div class="voucher-package-list-item">
    <img v-if="thumbnailUrl" :src="thumbnailUrl" :alt="name || ''" class="image" />
    <div class="meta">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column">
          <router-link :to="route" class="name">{{ name }}</router-link>
          <div>
            Pin order: <el-input
              ref="orderInput"
              :value="value.order"
              size="small"
              type="number"
              clearable
              style="width:120px"
              @input="$emit('input', { ...value, order: $event })"
              @change="handleOrderChange($event)"/>
          </div>
        </div>
        <div class="text-end">
          <span
            class="voucher-remove-button"
            @click="handleClickRemove"
          >
            <img src="/static/icons/trash.svg" alt="ลบ" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";

export default {
  components: {
    "el-input": Input
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    voucherId() {
      return this.value.id;
    },
    articleId() {
      return this.value.articleId;
    },
    thumbnailUrl() {
      return this.value.thumbnailUrl;
    },
    name() {
      return this.value.name;
    },
    route() {
      return this.value.route;
    }
  },
  methods: {
    handleClickRemove() {
      this.$emit("removeVoucher", { voucherId: this.voucherId, articleId: this.articleId });
    },
    handleOrderChange(newOrder) {
      if (newOrder === "" || newOrder === null || newOrder === undefined) {
        return;
      }
      this.$emit("updateOrder", { subscription_package_id: this.voucherId, order: newOrder })
    },
    orderInputHasFocus() {
      return document.activeElement === this.$refs.orderInput.getInput();
    },
    focusOrderInput() {
      this.$refs.orderInput.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 120px;

.voucher-package-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .image {
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: 90px;
    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: $space;
    display: block;

    flex-grow: 1;
  }
}

.meta {
  margin-top: -4px;
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }
}

.voucher-remove-button {
  display: inline-block;
  height: 32px;
  min-width: 32px;
  border-radius: 10em;
  border: 1px solid #e0e0e0;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;

  a {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: -0.1px;
    color: $black;
    padding: 3px 20px;
  }
}
</style>
